<template>

	<div class="bj_show">
		<div class="container-fluid-aa">
			<h4 class="z_01">{{list.community !=0 ?list.community:'暂无社区'}}</h4>
			<h6 class="z_01" v-if="list.assistance_paid == 2">有偿服务：{{list.assistance_money}}元</h6>
			<h6 class="z_01" v-if="list.assistance_paid == 1">无偿服务</h6>
			<h6 class="z_01" v-if="list.assistance_paid == 0">待设置</h6>
			<div class="container-fluid text-left tt_10">
				<div class="row-fluid">
					<div class="span12">

						<div class="row t_10">
							<div class="col-12 t_10">
								<h5>姓名：{{list.username}}</h5>
								<h5>电话：{{list.telephone}}</h5>
							</div>
							<div class="col-12 t_x_10 z_14">
								地址：{{list.assistance_address}}
							</div>
							<div class="col-12 tt_20"
								style="font-size:16px;line-height:150%; letter-spacing:1px; text-indent:32px;">
								{{list.assistance_text}}

							</div>

							<div class="col-12" v-if="list.assistance_file != ''" style="margin-top: 20px;">
								<img :src=img style="width: 100%;" />

							</div>

							<!-- <div class="col-12 t_10">
                <span class="label label-primary label_50">姓名</span>
                <span class="label label-primary label_50">姓名</span>
                <span class="label label-primary label_50">姓名</span>
                <span class="label label-primary label_50">姓名</span>
              </div> -->

						</div>
						<div style="margin-top: 15px; padding-top: 15px;"></div>
						<!-- <p style="height: 40px; line-height: 40px; background: #01b2c2;">.222222222..</p> -->

						<div v-for="(i,j) in list.assistance_listjson" :key="j">
							<div class="panel" style="background: #f3f4f8;">
								<div class="panel-heading" style=" background: #01b2c2; color: #fff;">
									{{i.title}}
								</div>
								<div class="panel-body" style="text-align: center; line-height: 30px; font-size: 14px;">
									<div>
										服务人员：{{i.value_amount}} 名
									</div>
									<div>
										服务积分：{{i.value_integral}} 分
									</div>
									<div>
										完成时间：{{i.value_time}}
									</div>
									<div>
										参与人数：{{i.rds_value}}
									</div>
									<div style="font-size: 12px; margin-top: 5px;"></div>
									<span v-if="i.rds_value<i.value_amount" class="label label-info"
										style="font-size: 14px; background: #01b2c2;" @click="order(i.id)">我要接单</span>
									<span v-if="i.rds_value>=i.value_amount" class="label label-info"
										style="font-size: 14px; background: #01b2c2;">
										已经满员
									</span>

								</div>
							</div>

						</div>
						<!-- <div class="col-12 b_t tt_10 t_x_10 text-center" @click="order">
              <button type="button" class="submit_btn" v-if="list.assistance_state == 0">等待接单</button>
              <button type="button" class="submit_btn" v-if="list.assistance_state == 1">已接单</button>
              <button type="button" class="submit_btn" v-if="list.assistance_state == 2">完成结单</button>
            </div> -->
					</div>
				</div>

			</div>
			<div style="margin-top: 80px;"></div>
		</div>
		<div id="d_p"></div>
		<pop :show5="showji" message="成功接单" @editshow="editshow" />
	</div>
</template>

<script>
	import pop from './popup.vue'
	//import user_model from '../tool/user_model'
	export default {
		data() {
			return {
				list: [],
				showji: false,
				t_list: [],
				img: ''
			}
		},
		components: {
			pop
		},
		props: {},
		created() {},
		mounted() {
			//查询id详细求助内容
			console.log(this.$route.query.id);
			this.$api.getAPI("mutual/assistance/" + this.$route.query.id +
					"?appid=202108&type_id=3001&state=1", {})
				.then(res => {
					// console.log(res.data.data.models);
					this.list = res.data.data.models
					//社区名称
					this.$api.getAPI("build/app/202108?state=1").then(res => {
						// console.log(res.data.data.frame_users);
						for (let j = 0; j < res.data.data.frame_users.length; j++) {
							if (this.list.community == res.data.data.frame_users[j].id) {
								// console.log(123);
								this.list.community = res.data.data.frame_users[j].value
							}
						}
						// console.log(this.list);
					})
					if (res.data.data.models.assistance_file != "") {
						this.img = res.data.data.models.assistance_file + "?x-oss-process=image/resize,w_500"
					}

				})
			//查询用户状态，是否接单等情况
			//mutual/task/?appid=202108&type_id=10001
			this.$api.getAPI("mutual/task/?appid=202108&type_id=10001", {
					key_id: this.$route.query.id,
					key_value: this.$api.getUserInfo().openid

				})
				.then(res => {
					console.log(res.data);
					var t = res.data.data.data[0];
					if (t.page.count == 0) {
						//当前用户没有接单
					} else {
						//建立一个数组
						//遍历
						for (var i = 0; i < t.models.length; i++) {
							this.t_list[i] = t.models[i].ojb_id
							//console.log(t.models[i].ojb_id);
						}

					}
					console.log(t);
					//this.list = res.data.data.models
					//this.img = res.data.data.models.assistance_file + "?x-oss-process=image/resize,w_500"
				})

		},
		methods: {

			//const openid = info.openid;

			editshow() {
				this.showji = false
				this.$router.push('/user_server_list')
			},
			order(id) {
				console.log(this.t_list);
				for (var i = 0; i < this.t_list.length; i++) {
					if (id == this.t_list[i]) {
						this.$Message.error("已经参与过该项目了！")
						return;
					}
				}
				//return
				//alert(this.t_list)
				//return;
				//alert(id)
				//let user_model=this.$api.getUserInfo().openid;
				//return
				//var info = this.$api.getUserinfo();
				// console.log(this.$route.query.id);
				let data = new FormData()
				//data.append('type_id', 3001)
				//data.append('cid', this.$route.query.id)
				//data.append('fid', id)
				data.append('object_username', this.$api.getUserInfo().username)
				data.append('object_telephone', this.$api.getUserInfo().telephone)


				// data.append('content_id', this.$route.query.id)
				// data.append('ojb_id', this.$route.query.id)
				data.append('openid', this.$api.getUserInfo().openid)
				// data.append('object_username',user_model.username)
				// data.append('object_telephone', user_model.telephone)
				// data.append('key_value',user_model.openid)

				// data.append('username', this.list.username)
				// data.append('telephone', this.list.telephone)
				// // data.append('content_name',name)
				// data.append('avatar_url', this.list.avatar_url)
				// // data.append('nick_name', this.list.nick_name)
				// // data.append('integral', this.list.assistance_money)
				// data.append('address', this.list.assistance_address)
				// data.append('time_complete', ctime)
				// data.append('openid', this.list.openid)
				// data.append('logistics', 1)
				// data.append('object_id', id)
				// data.append('object_name', name)
				// data.append('object_time', time)
				// data.append('key_id', key)
				// data.append('integral', integral)
				//{"id":10093,"key":"11","title":"理发服务1","value_amount":11,"value_integral":12,"rds_run":1}
				data.append('state', 1)
				this.$api.postAPI(
					`mutual/task_assistance/?appid=202108&type_id=10001&openid=` + this.$api.getUserInfo()
					.openid + "&cid=" + this.$route.query.id + "&typeid=3001&fid=" + id,
					data).then(res => {
					console.log(res);
					this.$Message.success("抢单成功！")
					this.$router.push('/user_server_list')
					//this.showji = true
					// alert('成功接单')
					// this.$router.push('/user_server_list')
				})
			}
		}
	}
</script>

<style>
	.submit_btn1 {
		margin-top: 20px;
		bottom: 0;
		width: 100%;
		border: 0;
		display: flex;
		justify-content: space-between;
		padding: 0 15px 0 15px;
		/* text-align: center; */
		line-height: 3em;
		font-size: 1em;
		color: #ffffff;
		background: #01b2c2;
	}

	.z_01 {
		color: #ffffff;
	}

	.container-fluid-aa {
		position: absolute;
		top: 4rem;
	}

	.tt_20 {
		padding-top: 20px;
	}

	.bj_show {
		background: #01b2c2;
		height: 12rem;
	}

	.jumbotron {
		padding: 1rem 1rem;
		margin-bottom: 1rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/help_show.vue